import { EXERCISE_KEY } from '../../constants'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getVideoUriExerciseUtil (exercise) {
  if (!exercise) {
    return
  }
  const video = getValueReduxUtil(exercise, EXERCISE_KEY.VIDEO)
  if (!video) {
    return
  }
  const id = getIdReduxUtil(exercise)
  return `exercise/${id}/${video}`
}

export default getVideoUriExerciseUtil
